/**
 * An interface for the Auth state
 */
export interface Auth {
  loggedIn: boolean;
  settingUser: boolean;
  user: adal.User;
  loginFailed: boolean;
  authStrategy: AuthStrategy;
  userType: string;
  isAuthenticated: boolean;
  authenticationStarted: boolean;
  authenticationEnded: boolean;
  oktaUserclaim?: OktaUserclaim;
}

export interface AuthState {
  readonly auth: Auth;
}

export enum AuthStrategy {
  OKTA = 'OKTA',
  MS = 'MS'
}

export interface OktaUserclaim {
  email?: string;
  cip_oid?: string;
  name?: string;
  given_name?: string;
  family_name?: string;
}
